export const CHECKOUT_FORM_NAME = 'checkoutForm';

export enum CheckoutFormSection {
    contactInfo = 'contactInfo',
    attendees = 'attendees',
    tosCheckbox = 'tosCheckbox',
    payment = 'payment',
}
